module.exports = __webpack_public_path__ + "img/ガレマルド.290e1468.png";